<template>
<div>

  <div v-if="!is_live">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
        <!-- <statistics-card-line
          hideChart
          class="mb-base"
          icon="HomeIcon"
          icon-right
          statistic="7"
          statisticTitle="Total Tenants" /> -->
      </div>

<!--      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
<!--        <statistics-card-line-->
<!--          hideChart-->
<!--          class="mb-base"-->
<!--          icon="ShoppingCartIcon"-->
<!--          icon-right-->
<!--          statistic="£ 0.00"-->
<!--          statisticTitle="Total Sales"-->
<!--          color="success" />-->
<!--      </div>-->

<!--      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
<!--        <statistics-card-line-->
<!--          hideChart-->
<!--          class="mb-base"-->
<!--          icon="BookmarkIcon"-->
<!--          icon-right-->
<!--          statistic="£ 0.00"-->
<!--          statisticTitle="Purchase Due"-->
<!--          color="danger" />-->
<!--      </div>-->

<!--      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">-->
<!--        <statistics-card-line-->
<!--          hideChart-->
<!--          class="mb-base"-->
<!--          icon="AlertOctagonIcon"-->
<!--          icon-right-->
<!--          statistic="£ 0.00"-->
<!--          statisticTitle="Invoice Due"-->
<!--          color="warning" />-->
<!--      </div>-->
    </div>
  </div>
</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData'
import VueApexCharts from 'vue-apexcharts'
import store from '../store/store.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import { is_live } from "@/constants/config";


export default {
  components: {
    StatisticsCardLine,
    VueApexCharts,
    ChangeTimeDurationDropdown
  },
  data () {
    return {
      is_live: is_live,
      activeItem: 0,
      subscribers_gained: {
        series: [
          {
            name: 'Subscribers',
            data: [0, 0, 0, 0]
          }
        ],
        analyticsData: {
          subscribers: 0
        }
      },
      revenueGenerated: {
        series: [
          {
            name: 'Revenue',
            data: [0, 0, 0]
          }
        ],
        analyticsData: {
          revenue: 0
        }
      },
      quarterlySales: {
        series: [
          {
            name: 'Sales',
            data: [0, 0, 0]
          }
        ],
        analyticsData: {
          sales: '0%'
        }
      },
      ordersRecevied: {
        series: [
          {
            name: 'Orders',
            data: [0, 0, 0]
          }
        ],
        analyticsData: {
          orders: 0
        }
      },
      analyticsData,
      revenueComparisonLine: {
        analyticsData: {
          thisMonth: 0,
          lastMonth: 0
        },
        series: [
          {
            name: 'This Month',
            data: [0, 0, 0]
          },
          {
            name: 'Last Month',
            data: [0, 0, 0]
          }
        ]
      },
      clientRetentionBarChartOptions: {
        grid: {
          borderColor: '#ebebeb',
          padding: {
            left: 0,
            right: 0
          }
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        chart: {
          stacked: true,
          type: 'bar',
          toolbar: { show: false }
        },
        colors: [ '#ffb921', '#AA2EE6'],
        plotOptions: {
          bar: {
            columnWidth: '10%'
          }
        },
        xaxis: {
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            }
          },
          axisTicks: {
            show: false
          },
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: {
              cssClass: 'text-grey fill-current'
            }
          }
        },
        tooltip: {
          x: { show: false }
        }
      },
      clientRetentionBar: {
        series: [
          {
            name: 'Steps',
            data: [175, 125, 225, 175, 160, 189, 206, 134, 159, 216, 148, 123]
          },
          {
            name: 'Retained Clients',
            data: [-144, -155, -141, -167, -122, -143, -158, -107, -126, -131, -140, -137]
          }
        ],
        series2: [
          {
            name: 'Steps',
            data: [ 206,206, 2,134, 159, 216, 148, 123, 65]
          },
          {
            name: 'Retained Clients',
            // data: [-144, -155, -141, -167, -122, -143, -158, -107, -126, -131, -140, -137]
          }
        ]
      },
    }
  },
  mounted() {

  }
}
</script>


<style lang="scss">
  /*! rtl:begin:ignore */
  #dashboard-analytics {
    .greet-user{
      position: relative;

      .decore-left{
        position: absolute;
        left:0;
        top: 0;
      }
      .decore-right{
        position: absolute;
        right:0;
        top: 0;
      }
    }

    @media(max-width: 576px) {
      .decore-left, .decore-right{
        width: 140px;
      }
    }
  }
  /*! rtl:end:ignore */
</style>
